enum AnswerSource {
    DEFAULT,
    EVALUATION_ASSISTANCE,
    AI_SCORING,
    USER,
    SYSTEM,
}

export default AnswerSource;
